import { WIZARD } from './helperV2';

export const clampWizardToDocumentGate = ({
    wizard,
    sequence = [],
    documentFirst = false,
    gateOpen = false,
} = {}) => {
    if (!documentFirst || gateOpen) return wizard;

    const wizardSequence = Array.isArray(sequence) ? sequence : [];
    const gateIndex = wizardSequence.indexOf(WIZARD.Documents);
    const targetIndex = wizardSequence.indexOf(wizard);

    if (gateIndex < 0 || targetIndex < 0 || targetIndex <= gateIndex) return wizard;

    return WIZARD.Documents;
};

export default clampWizardToDocumentGate;

